import { createTheme } from '@mui/material/styles';

export const materialTheme = createTheme({
    palette: {
        primary: {
            main: '#F3EDE9',
            fontColor: '#184353',
            button: '#FF5F39',
            colorGreen: 'var(--Status-Success, #75BD2F)',
            borderColor: 'var(--Structural-Structure-2, #E1E1E1)',
            primaryColor:'#184353'
            // Custom primary color
        },
        secondary: {
            main: '#FFFFFF',
            button: '#FCEFEC',
        },
        tertiary: {
            main: '#000000', // Custom secondary color
        },
    },
});
